export let LiveSiteDispatchModalClosedTriggerName = /*#__PURE__*/function (LiveSiteDispatchModalClosedTriggerName) {
  LiveSiteDispatchModalClosedTriggerName["SAVE_BUTTON"] = "save";
  LiveSiteDispatchModalClosedTriggerName["X_BUTTON"] = "x_button";
  LiveSiteDispatchModalClosedTriggerName["CLICK_OUTSIDE_MODAL"] = "click_outside_modal";
  return LiveSiteDispatchModalClosedTriggerName;
}({});
export let LiveSiteDispatchModalClosedSelectedRadioButton = /*#__PURE__*/function (LiveSiteDispatchModalClosedSelectedRadioButton) {
  LiveSiteDispatchModalClosedSelectedRadioButton["ASAP_RADIO_BUTTON"] = "ASAP_RADIO_BUTTON";
  LiveSiteDispatchModalClosedSelectedRadioButton["FUTURE_RADIO_BUTTON"] = "FUTURE_RADIO_BUTTON";
  return LiveSiteDispatchModalClosedSelectedRadioButton;
}({});
export let LiveSiteDispatchModalClosedSchedulingType = /*#__PURE__*/function (LiveSiteDispatchModalClosedSchedulingType) {
  LiveSiteDispatchModalClosedSchedulingType["ASAP"] = "ASAP";
  LiveSiteDispatchModalClosedSchedulingType["SAME_DAY"] = "SAME_DAY";
  LiveSiteDispatchModalClosedSchedulingType["ASAP_AND_FUTURE"] = "ASAP_AND_FUTURE";
  LiveSiteDispatchModalClosedSchedulingType["PRE_ORDER"] = "PRE_ORDER";
  return LiveSiteDispatchModalClosedSchedulingType;
}({});
//# sourceMappingURL=constants.js.map